<template>
    <div class="item-list">
        <!-- <el-checkbox-group v-model="checkList">
            <el-checkbox v-for="(item, index) in config.list" :key="index" :label="item.name">{{ item.name
                }}</el-checkbox>
        </el-checkbox-group> -->
        <div class="item" :class="{ 'active': checkList.includes(item.name) }" v-for="(item, index) in config.list"
            :key="index" @click="handleCheck(item, index)">{{
            item.name }}</div>
        <!-- 弹出框 -->
        <FormDialog :visible.sync="showDialog" :content="content" />
    </div>
</template>

<script>
import { isEmpty } from '@/utils'
import FormDialog from '@/components/dialog'
export default {
    name: 'FormCheckbox',
    components: {
        FormDialog
    },
    props: {
        value: {
            type: Array,
            default: []
        },
        config: {
            type: Object,
            default: {}
        }
    },
    model: {
        event: 'change'
    },
    watch: {
        checkList(value) {
            this.$emit('change', value)
        },
        value(value) {
            this.checkList = value
        }
    },
    created() { },
    mounted() {

    },
    data() {
        return {
            checkList: this.value,
            showDialog: false,
            content: '',
        }
    },
    methods: {
        handleCheck(item, index) {
            if (this.checkList.includes(item.name)) {
                this.checkList.splice(this.checkList.indexOf(item.name), 1)
            } else {
                this.checkList.push(item.name)
                if (!isEmpty(item.tips)) {
                    this.content = item.tips;
                    this.showDialog = true;
                }
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.item-list {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;

    .item {
        background: #fff;
        border: 1px solid #efefef;
        color: #666;
        padding: 0px 20px;
        margin-bottom: 5px;
        cursor: pointer;
        box-sizing: content-box;
        border-radius: 5px;
        margin-right: 10px;
        font-size: 13px;

        &.active {
            background: #00b4e8;
            color: #FFF;
            border: 1px solid #00b4e8;
        }
    }
}
</style>